import { AxiosPromise } from 'axios';
import { IReceptionLoginPageFormValues } from './types';
import { instance } from '../../../services';

const attemptReceptionLogin = (
  data: IReceptionLoginPageFormValues,
): AxiosPromise => instance.post('api/accounts/reception', data);

export default attemptReceptionLogin;
